export default [
    {
        path: '/users',
        component: () => import('@/views/User'),
        props: true,
    },
    {
        path: '/profile',
        component: () => import('@/views/User/Profile'),
        props: true,
    },
    {
        path: '/agenda',
        component: () => import('@/views/User/Agenda'),
        props: true,
    },
];
